import api from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import { URL_BACK } from '../../viariableProd'
const updateTokenSesion = URL_BACK + '/updateTokenSesion.php'
const deleteTokenSesion = URL_BACK + '/deleteTokenSesion.php'
Vue.use(Vuex, VueAxios, api)

//  const SECRET = 'e2ab018979a3c007014c10efb3b0c3fe'
// var CryptoJS = require('crypto-js')
// var data = localStorage.getItem('urlLogin')
// var bytes = CryptoJS.AES.decrypt(data, SECRET)
// var originalText = bytes.toString(CryptoJS.enc.Utf8)
// var originalText = localStorage.getItem('urlLogin')
// const path = apiRegistroAnecsa + '?subnet=cmo2022&email='

// const path = 'https://intermeetingonline.com.mx/apiAWS/api_registro_anecsa_comg23.php?subnet=comg23&email='
// config Basic authentication request
const config = {
  auth: {
    username: '',
    password: ''
  }
}

export default {
  searchUser (credentials) {
    return new Promise((resolve, reject) => {
      config.auth.username = credentials.email
      config.auth.password = credentials.password
      const subnet = localStorage.getItem('subnet')
      const url = `${URL_BACK}/api_registro_anecsa_${subnet}.php?subnet=${subnet}&email=${config.auth.username}&password=${config.auth.password}`
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTokenSesion (credentials) {
    return new Promise((resolve, reject) => {
      var url = updateTokenSesion + '?email=' + credentials.email + '&token=' + credentials.newToken + '&subnet=' + localStorage.getItem('subnet')
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTokenSesion (credentials) {
    if (credentials) {
      return new Promise((resolve, reject) => {
        api
          .post(deleteTokenSesion + '?subnet=' + localStorage.getItem('subnet'), credentials)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js